import { useTranslation } from 'react-i18next';
import DeleteForeverOutlined from '@mui/icons-material/DeleteForeverOutlined';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Constants from 'style/constants';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';

import styles from './wandering-boundary-card.module.scss';

type Props = {
  name: string;
  description?: string;
  onUnlinkClicked: () => void;
  viewingMode: ViewingMode;
};

const WanderingBoundaryCard = ({ name, description, onUnlinkClicked, viewingMode }: Readonly<Props>): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings');

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
      <div className={styles.textContainer}>
        <Typography variant="subtitle1">{t('scenarioConfiguration.name')}</Typography>
        <Typography variant="caption">{name}</Typography>
        {description && (
          <>
            <Typography variant="subtitle1">{t('scenarioConfiguration.description')}</Typography>
            <Typography variant="caption">{description}</Typography>
          </>
        )}
      </div>
      {viewingMode === 'editing' && (
        <IconButton onClick={onUnlinkClicked} sx={{ padding: 0 }}>
          <DeleteForeverOutlined sx={{ color: Constants.Colors.primary, width: 30, height: 30 }} />
        </IconButton>
      )}
    </Stack>
  );
};

export default WanderingBoundaryCard;
